import type { MouseEvent } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';

interface QuantityCounterProps {
  value: number;
  min?: number;
  max?: number;
  onChange: (value: number) => void;
}

export const QuantityCounter = ({ value, min = 1, max, onChange }: QuantityCounterProps) => {
  const handleDecrement = (e: MouseEvent) => {
    e.stopPropagation();

    const newValue = value > min ? value - 1 : value;
    onChange(newValue);
  };

  const handleIncrement = (e: MouseEvent) => {
    e.stopPropagation();

    const newValue = !max || value < max ? value + 1 : value;
    onChange(newValue);
  };

  return (
    <Card variant="quantityCounter">
      <Box className="QuantityCounter-button" onClick={handleDecrement} role="button">
        <RemoveRoundedIcon />
      </Box>
      <Box className="QuantityCounter-value">
        <Typography variant="body.md" className="QuantityCounter-valueText">
          {value}
        </Typography>
      </Box>
      <Box className="QuantityCounter-button" onClick={handleIncrement} role="button">
        <AddRoundedIcon />
      </Box>
    </Card>
  );
};
